// Session 52 · Leaflet default-icon fix.
//
// Leaflet's built-in Icon.Default resolves marker asset URLs relative to the
// CSS import, which fails under CRA/webpack (paths get hashed away). Rebind
// to the CDN copies once at app load so every marker renders.
import L from "leaflet";

let bound = false;
export function overrideDefaultIcon() {
  if (bound) return;
  bound = true;
  L.Icon.Default.mergeOptions({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  });
}
